export default "__VITE_ASSET__8e1b19c1__"